var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.PgTable,_vm._g(_vm._b({ref:"tableRef",staticClass:"pg-table-drag",attrs:{"stripe":_vm.stripe,"selectAndSeqFixed":_vm.selectAndSeqFixed,"rowConfig":_vm.rowConfig}},'PgTable',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }